import { useState } from "react";
import { useCookies } from "react-cookie";
import { useSelector } from "react-redux";
import { selectIsAuth, selectServerSettings } from "../../store/selectors";
import { RolledInfoArrow } from "../RolledInfoArrow/RolledInfoArrow";
import { FormInput } from "../widgets/FormInput";

// eslint-disable-next-line import/prefer-default-export
export const LoanAmount = () => {
  const [cookies, setCookie] = useCookies();

  const isAuth = useSelector(selectIsAuth);
  const serverSettings = useSelector(selectServerSettings);
  const isPrescoringSumMin = serverSettings?.UsePrescoringSumMin;
  const isLoanAmount = isAuth && isPrescoringSumMin;

  const [opened, setOpened] = useState(false);

  const changeCheckbox = ({ target }) => {
    setCookie("term", target.checked);
  };

  if (!isLoanAmount) return null;

  return (
    <div className="details-wrapper">
      {opened && (
        <FormInput
          className="item-checkbox-wrapper"
          id="optimalLoanAmount"
          titleText="Подобрать оптимальную сумму займа"
          hideValidation>
          <input
            id="optimalLoanAmount"
            type="checkbox"
            className="checkbox"
            data-testid="optimalLoanAmount-input"
            checked={cookies.term !== undefined ? cookies.term : true}
            onChange={(e) => changeCheckbox(e)}
          />
        </FormInput>
      )}
      <RolledInfoArrow isOpened={opened} setIsOpened={setOpened} />
    </div>
  );
};
